export default "__VITE_ASSET__6RXP3IG1__"